module.exports = __webpack_public_path__ + "static/media/sun.ad1cf69f.svg";